import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { Sparkles } from 'lucide-react';

export default function Footer() {
  const { isDark } = useTheme();
  const currentYear = new Date().getFullYear();

  return (
    <footer className={`py-12 border-t ${
      isDark ? 'border-gray-800' : 'border-gray-200'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Logo et description */}
          <div className="col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-primary-500 to-purple-600 flex items-center justify-center">
                <Sparkles className="w-4 h-4 text-white" />
              </div>
              <span className={`text-lg font-bold ${
                isDark ? 'text-white' : 'text-gray-900'
              }`}>
                Insight360
              </span>
            </div>
            <p className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
              CRM nouvelle génération pour équipes performance
            </p>
          </div>

          {/* Liens rapides */}
          <div>
            <h4 className={`text-sm font-semibold mb-4 ${
              isDark ? 'text-gray-300' : 'text-gray-700'
            }`}>
              Produit
            </h4>
            <ul className="space-y-2">
              <li><a href="#features" className={`text-sm ${
                isDark ? 'text-gray-400 hover:text-gray-300' : 'text-gray-500 hover:text-gray-600'
              }`}>Fonctionnalités</a></li>
              <li><a href="#pricing" className={`text-sm ${
                isDark ? 'text-gray-400 hover:text-gray-300' : 'text-gray-500 hover:text-gray-600'
              }`}>Tarifs</a></li>
              <li><a href="#demo" className={`text-sm ${
                isDark ? 'text-gray-400 hover:text-gray-300' : 'text-gray-500 hover:text-gray-600'
              }`}>Démo</a></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className={`text-sm font-semibold mb-4 ${
              isDark ? 'text-gray-300' : 'text-gray-700'
            }`}>
              Support
            </h4>
            <ul className="space-y-2">
              <li><a href="#" className={`text-sm ${
                isDark ? 'text-gray-400 hover:text-gray-300' : 'text-gray-500 hover:text-gray-600'
              }`}>Documentation</a></li>
              <li><a href="#" className={`text-sm ${
                isDark ? 'text-gray-400 hover:text-gray-300' : 'text-gray-500 hover:text-gray-600'
              }`}>Contact</a></li>
              <li><a href="#" className={`text-sm ${
                isDark ? 'text-gray-400 hover:text-gray-300' : 'text-gray-500 hover:text-gray-600'
              }`}>FAQ</a></li>
            </ul>
          </div>

          {/* Légal */}
          <div>
            <h4 className={`text-sm font-semibold mb-4 ${
              isDark ? 'text-gray-300' : 'text-gray-700'
            }`}>
              Légal
            </h4>
            <ul className="space-y-2">
              <li><a href="#" className={`text-sm ${
                isDark ? 'text-gray-400 hover:text-gray-300' : 'text-gray-500 hover:text-gray-600'
              }`}>CGV</a></li>
              <li><a href="#" className={`text-sm ${
                isDark ? 'text-gray-400 hover:text-gray-300' : 'text-gray-500 hover:text-gray-600'
              }`}>Confidentialité</a></li>
              <li><a href="#" className={`text-sm ${
                isDark ? 'text-gray-400 hover:text-gray-300' : 'text-gray-500 hover:text-gray-600'
              }`}>Mentions légales</a></li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className={`pt-8 border-t ${
          isDark ? 'border-gray-800' : 'border-gray-200'
        }`}>
          <p className={`text-sm text-center ${
            isDark ? 'text-gray-400' : 'text-gray-500'
          }`}>
            © {currentYear} Insight360. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
}